import { PrimaryRecommendationProgramDetailScreen } from '@/components/PrimaryRecommendationProgramDetailScreen';

export default function PrimaryRecommendationProgramDetail() {
  return <PrimaryRecommendationProgramDetailScreen />;
}
